import { render, staticRenderFns } from "./enterprise.vue?vue&type=template&id=620bb81f&scoped=true"
import script from "./enterprise.vue?vue&type=script&lang=js"
export * from "./enterprise.vue?vue&type=script&lang=js"
import style0 from "./enterprise.vue?vue&type=style&index=0&id=620bb81f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620bb81f",
  null
  
)

export default component.exports